export enum DnaTestTrackingStatus {
    Purchased = "purchased",
    Delivered = "delivered",
    TestDone = "test_done",
    SampleRegistered = "sample_registered",
    PickupRequested = "pickup_requested",
    Departed = "departed",
    DeliveredToLaboratory = "delivered_to_laboratory",
    StartingToExtract = "starting_to_extract",
    StartingAnalysis = "starting_analysis",
    AnalysisDone = "analysis_done",
    ReportGenerated = "report_generated"
}